export { RatingComponent } from './rating.component';
export { RatingModule } from './rating.module';



// WEBPACK FOOTER //
// ./.tmp/rating/index.ts